import { Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { LocationService } from "../../services/location.service";
import { ThemeService } from "../../services/theme.service";
import { CommonModule, isPlatformBrowser } from "@angular/common";
import { DialogModule } from "primeng/dialog";
import { ScrollTopModule } from "primeng/scrolltop";
import { CarouselModule } from "primeng/carousel";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { UuidInviteCardComponent } from "./uuid-invite-card/uuid-invite-card.component";
import { landingServices } from "../landing.service";
import { BrowserService } from "../../services/browser.service";

@Component({
  selector: "uni-landing-content",
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    RouterModule,
    ScrollTopModule,
    CarouselModule,
    UuidInviteCardComponent,
  ],
  templateUrl: "./landing-content.component.html",
  styleUrls: ["./landing-content.component.scss"],
})
export class LandingContentComponent implements OnInit {
  isPlaying = false;
  isDarkMode: boolean;
  currentImage: string = "/uniprep-assets/images/feature1.webp";
  blogs: any;
  videoUrl: string = `https://www.youtube.com/embed/AAXUZ0z5bl0?si=fkMUZWejNm7qfSTs?rel=0&autoplay=1`;
  embedUrl!: SafeResourceUrl;
  isInitialLoadVideo: boolean = true;
  uuid: string | null = null;

  responsiveOptions = [
    {
      breakpoint: "1199px",
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: "991px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  isFromUUID = false;
  isJobList: boolean = false;
  uuidCardData: any = null;
  currentUrl: string = "";
  isJobLink: boolean = false;
  isCompanyLink: boolean = false;
  isTalentLink: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    private themeService: ThemeService,
    private service: LocationService,
    private router: Router,
    private browserService: BrowserService,
    private route: ActivatedRoute,
    private landingService: landingServices,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    // Initialize the isDarkMode property with the value from the service
    this.isDarkMode = this.themeService.getInitialSwitchState();
  }

  timeLeftInfoCard: any;
  encodeUrl: any;
  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.uuid = params["uuid"];
      this.currentUrl = this.router.url;

      this.isJobList = this.currentUrl.includes("/jobs");
      this.isJobLink =
        this.currentUrl.startsWith("/job") ||
        this.currentUrl.startsWith("/view");
      this.isCompanyLink = this.currentUrl.startsWith("/company");
      this.isTalentLink = this.currentUrl.startsWith("/talent");
      this.isFromUUID = !!this.uuid;

      if (this.isJobLink) {
        let data = {
          page: 1,
          perPage: 8,
          city_id: 16199,
          keyword: "uniprep",
          position: "",
          company_name: "",
          industry: null,
          country: null,
          worklocation: null,
          work_mode: null,
          employment_type: null,
          currency: null,
          min_salary: "",
          max_salary: "",
          experienceLevel: null,
          salary_currency: null,
          hiringStatus: null,
          intro: null,
          job_type: null,
          hiring_type: null,
        };
        // this.landingService.getJobInviteDetailsNew(data).subscribe((res) => {
        //     this.uuidCardData = res?.data;
        // });
      }
      // else if (this.uuid && this.isCompanyLink) {
      //   this.landingService.getCompanyInviteDetails(this.uuid).subscribe((res) => {
      //     this.uuidCardData = res?.data;
      //   });
      // }
      else {
        this.isFromUUID = false;
      }

      // `featuredBlog` is not needed for job detail pages and breaks SSR
      // when the backend host is unreachable. Only load it on the browser
      // and only when we're not on job/invite routes.
      if (isPlatformBrowser(this.platformId) && !this.isJobLink) {
        this.service.getFeatBlogs().subscribe((response) => {
          this.blogs = response.slice(0, 8);
        });
      }
    });

    this.timeLeftInfoCard = "24 Hours";
    this.currentImage = "/uniprep-assets/images/uf1.webp";
  }
}
